module.exports = __webpack_public_path__ + "static/macworld_bg-9a13a540d0a1c598cfed133e7db9ce6b.png";